import React, { memo, useState } from "react";
import { Handle, Position, NodeResizer, useReactFlow } from "@xyflow/react";

const GroupNode = ({ data, id, selected }: any) => {
  const { setNodes } = useReactFlow();

  // Estados para largura e altura
  const [width, setWidth] = useState(data.width || 200);
  const [height, setHeight] = useState(data.height || 150);

  // Função para atualizar o tamanho do nó
  const handleResize = (
    event: any,
    size: { width: number; height: number }
  ) => {
    setWidth(size.width);
    setHeight(size.height);

    // Atualizar o tamanho no estado do React Flow
    setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                width: size.width,
                height: size.height,
              },
            }
          : node
      )
    );
  };
  function hexToRgba(hex: string, alpha: number): string {
    if (!hex) {
      return "rgba(0, 119, 255, 0.1)";
    }
    // Remover o caractere '#' se estiver presente
    hex = hex.replace("#", "");

    // Converter cores do tipo '#RGB' para '#RRGGBB'
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((char) => char + char)
        .join("");
    }

    // Obter os valores de R, G e B
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    // Retornar a string no formato rgba
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return (
    <div
      style={{
        position: "relative",
        width: `${width}px`,
        height: `${height}px`,
        border: data.border ? "2px dashed" : "none",
        borderRadius: "8px",
        padding: "10px",
        backgroundColor: hexToRgba(data.color, 0.2),
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Label do grupo */}
      <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
        {data.label}
      </div>

      {/* NodeResizer para redimensionar o grupo */}
      <NodeResizer
        color="#0077ff"
        isVisible={selected}
        // minWidth={100}
        // minHeight={100}
        keepAspectRatio={false}
        onResize={handleResize}
      />
    </div>
  );
};

export default memo(GroupNode);
